import * as Constants from '../constants';

export function getSuggestions({ stationId, seedMusicId, maxResults }) {
  return {
    type: Constants.StationDetails.actions.GET_SUGGESTIONS,
    data: {
      stationId,
      seedMusicId,
      maxResults,
    },
  };
}

export function getStationDetails({ stationId }) {
  return {
    type: Constants.StationDetails.actions.GET_DETAILS,
    data: {
      stationId,
    },
  };
}

export function addSeed({ stationId, musicId }) {
  return {
    type: Constants.StationDetails.actions.ADD_SEED,
    data: {
      stationId,
      musicId,
    },
  };
}

export function getSeeds({ stationId }) {
  return {
    type: Constants.StationDetails.actions.GET_SEEDS,
    data: {
      stationId,
    },
  };
}

export function deleteSeed({ stationId, musicId }) {
  return {
    type: Constants.StationDetails.actions.DELETE_SEED,
    data: {
      stationId,
      musicId,
    },
  };
}

export function resetThumbList() {
  return {
    type: Constants.StationDetails.actions.RESET_STATION_FEEDBACK_SUCCESS,
  };
}

export function launchAddVariety() {
  return {
    type: Constants.StationDetails.actions.LAUNCH_ADD_VARIETY,
  };
}

export function leaveStationDetails() {
  return {
    type: Constants.StationDetails.actions.LEAVE_STATION_DETAILS,
  };
}

export function disableVideoAdsForStation() {
  return {
    type: Constants.StationDetails.actions.DISABLE_VIDEO_ADS_FOR_STATION,
  };
}
